(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-reveal],[data-scale]').forEach(function (el) { io.observe(el); });
  }

  function initScroll() {
    var bar = document.getElementById('ScrollProgress');
    var pattern = document.querySelector('.hero-pattern');
    function onScroll() {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var pct = Math.min(100, (window.scrollY / max) * 100);
      if (bar) bar.style.width = pct + '%';
      if (pattern && !reduce) pattern.style.transform = 'translateY(' + (window.scrollY * 0.15) + 'px)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initCursor() {
    var dot = document.getElementById('CursorDot');
    if (!dot || window.matchMedia('(hover: none)').matches) return;
    window.addEventListener('mousemove', function (e) {
      dot.style.left = e.clientX + 'px';
      dot.style.top = e.clientY + 'px';
      dot.classList.add('is-active');
      var hit = e.target.closest && e.target.closest('a,button,.itin-card,.card-product');
      dot.classList.toggle('is-hover', !!hit);
    });
    document.addEventListener('mouseleave', function () { dot.classList.remove('is-active'); });
  }

  function initMenu() {
    var overlay = document.getElementById('MenuOverlay');
    if (!overlay) return;
    function toggle() { overlay.classList.toggle('is-open'); }
    document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.addEventListener('click', toggle); });
    overlay.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { overlay.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') overlay.classList.remove('is-open');
    });
  }

  function initGripDemo() {
    var panel = document.querySelector('[data-grip-demo]');
    if (!panel) return;
    var range = panel.querySelector('input[type=range]');
    if (!range) return;
    var out = panel.querySelector('[data-gc-val]');
    var lattice = panel.querySelector('[data-gc-lattice]');
    var foam = panel.querySelector('[data-gc-foam]');
    function set(name, text) {
      var el = panel.querySelector('[data-gc-' + name + ']');
      if (el) el.textContent = text;
    }
    function update() {
      var p = Number(range.value);
      if (out) out.textContent = p + '%';
      if (lattice) lattice.style.transform = 'scale(' + (1.15 - p * 0.0035) + ',' + (1 - p * 0.0005) + ')';
      if (foam) foam.style.transform = 'scale(' + (1 + p * 0.003) + ',' + (1 + p * 0.0005) + ')';
      set('contact', '+' + Math.round(p * 0.6) + '%');
      set('density', '+' + Math.round(p * 0.5) + '%');
      set('force', '\u2212' + Math.round(p * 0.4) + '%');
      set('foamcontact', '\u2212' + Math.round(p * 0.2) + '%');
      set('foamwidth', '\u2212' + Math.round(p * 0.3) + '%');
      set('foamforce', '+' + Math.round(p * 0.5) + '%');
    }
    range.addEventListener('input', update);
    update();
  }

  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    var dataEl = document.getElementById('ProductVariantsJSON');
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name=id]');
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[type=submit]');
    var mediaImg = document.querySelector('[data-product-media] img');
    function chosen() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        if (input.checked) opts[Number(input.getAttribute('data-option-index'))] = input.value;
      });
      return opts;
    }
    function update() {
      var opts = chosen();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (opts[j] && opts[j] !== v.options[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to Cart' : 'Sold out';
      }
      if (mediaImg && match.image) mediaImg.src = match.image;
    }
    form.querySelectorAll('[data-option-index]').forEach(function (i) {
      i.addEventListener('change', update);
    });
    update();
  }

  function init() {
    initReveal(); initScroll(); initCursor(); initMenu(); initGripDemo(); initVariants();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
